import React from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'

import { historyUtils } from '@wartek-id/toolbox-helper'

import { EmptyState, EmptyStateAction } from 'components/EmptyState'
import { useSafeRouter } from 'hooks/useSafeRouter'
import ResponsiveErrorLayout from './ResponsiveErrorLayout'

import type { FallbackProps } from 'react-error-boundary'

export function PelatihanErrorFallback({
  error,
  resetErrorBoundary,
}: FallbackProps) {
  const router = useRouter()
  const { safeReplace } = useSafeRouter()
  // @ts-expect-error error is not an Error object
  const { title, description } = error

  return (
    <ResponsiveErrorLayout
      mobileOnBack={() =>
        historyUtils.backToApp(() => {
          resetErrorBoundary()
          router.back()
        })
      }
    >
      {(isDesktop) => (
        <>
          <Head>
            <title>{title}</title>
          </Head>
          <EmptyState
            title={title}
            description={description}
            fullscreen={!isDesktop}
            className={isDesktop ? 'min-h-[320px]' : undefined}
          >
            <EmptyStateAction
              className={isDesktop ? 'mb-4 max-w-sm' : undefined}
              color="black"
              onClick={() => {
                safeReplace(
                  `/${
                    process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH ||
                    'pelatihan-mandiri'
                  }`
                )
              }}
            >
              Kembali ke daftar Topik
            </EmptyStateAction>
          </EmptyState>
        </>
      )}
    </ResponsiveErrorLayout>
  )
}

export default PelatihanErrorFallback
